<span #price class="custom-old-price">
    R$ {{value}}
   <mat-icon  class="old-price-line" svgIcon="promo-old-price-line"></mat-icon>
</span>